module.exports = __webpack_public_path__ + "img/shield1.b1cec490.png";